import { ReactNode } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper } from '@fortawesome/pro-light-svg-icons'

import { formatDate } from '@domain-group/javascript-utils'

import { Box, Form, Text } from '@domain-group/suit-theme'

import type { PublicationEditionModel } from '@models/types'

import DateBadge from '../DateBadge'

import Deadline from './Deadline'

interface PublicationEditionHeaderProps {
  children?: ReactNode,
  publicationEdition: PublicationEditionModel,
  publicationTitle: string,
}

const PublicationEditionHeader = (props: PublicationEditionHeaderProps) => {
  const {
    children, publicationEdition, publicationTitle,
  } = props
  const { publication_date: publicationDate } = publicationEdition

  const dateBadgeDateString = formatDate(publicationDate, 'dd/MM/yyyy', 'yyyy-MM-dd')

  return (
    <Box
      alignItems="center"
      borderBottom="1px solid"
      borderColor="lineColor"
    >
      <DateBadge dateString={dateBadgeDateString} />

      <Box padding="large">
        <Box flexDirection="column" maxWidth="60%">
          <Form.Field label="Publication">
            <Box alignItems="center" fontSize="small" marginTop="small">
              <FontAwesomeIcon icon={faNewspaper} />
              <Text marginLeft="small">
                {publicationTitle}
              </Text>
            </Box>
          </Form.Field>
        </Box>

        <Box
          alignItems="flex-end"
          display={['none', 'flex']}
          flexDirection="column"
          justifyContent="center"
          marginLeft="auto"
          width="auto"
        >
          {children}
        </Box>
      </Box>
    </Box>

  )
}

PublicationEditionHeader.Deadline = Deadline

export default PublicationEditionHeader
